import { useLightMode } from '@/hooks/useLightMode'
import { useTranslation } from 'react-i18next'
import { HiExclamation } from 'react-icons/hi'

import { Alert, Box, Flex, Icon, SlideFade } from '@chakra-ui/react'

import { Button } from '@/components/ui'
import { tVar } from '@/utils/i18n'

interface DeviceMisconfiguredAlertIProps {
  count: number
  onClick: () => void
  /** Bottom margin; 0 when rendered inline next to other controls. */
  mb?: number
}

export const DeviceMisconfiguredAlert = ({
  count,
  onClick,
  mb = 4,
}: DeviceMisconfiguredAlertIProps) => {
  const { t } = useTranslation()
  const mode = useLightMode()
  const isPlural = count > 1

  return (
    <SlideFade in>
      <Alert
        bg={`bg.alert-danger.${mode}`}
        borderRadius='10px'
        color={`text.alert-danger-bold.${mode}`}
        mb={mb}
        // 24px button + 6px padding = the same 36px height as the sibling
        // success/warning result panels (20px icon + 8px padding)
        py='6px'
        status='error'
      >
        <Icon as={HiExclamation} boxSize='20px' mr='10px' />
        <Box fontSize='14px' fontWeight={500}>
          {tVar(
            t,
            isPlural
              ? 'automations:device_misconfigured_alert_count_doors'
              : 'automations:device_misconfigured_alert_count_door',
            { count }
          )}
        </Box>
        <Flex flex={1} justifyContent='flex-end'>
          <Button
            borderColor={`text.alert-danger-bold.${mode}`}
            color={`text.alert-danger-bold.${mode}`}
            fontSize='12px'
            h='24px'
            onClick={onClick}
            px='8px'
            rounded='0px'
            variant='v2-ghost'
          >
            {isPlural
              ? t('automations:device_misconfigured_view_doors')
              : t('automations:device_misconfigured_view_door')}
          </Button>
        </Flex>
      </Alert>
    </SlideFade>
  )
}
